<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-lg-between">
            <h6 class="card-title">نمایش تیکت ها</h6>
          </div>
          <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
              ایجاد تیکت
          </button>
          <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalCenterTitle">ایجاد تیکت</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="بستن">
                    <i class="ti-close"></i>
                  </button>
                </div>
                <form class="border" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)">
                  <div class="modal-body">
                    <div class="con-form">
                      <div class="form-row d-flex justify-content-center">
                        <div class="col-md-12 mb-3">
                          <label for="validationCustom01">عنوان
                              <span class="text-danger">*</span>
                          </label>
                          <input type="text" class="form-control" placeholder="عنوان تیکت را وارد کنید!" name="title" v-model="form.title">
                          <span class="help text-danger" v-if="form.errors.has('title')" v-text="form.errors.get('title')"></span>
                        </div>
                      </div>
                    </div>
                    <div class="form-row d-flex justify-content-center">
                      <div class="col-md-12 mb-3">
                        <label for="">متن پیام را وارد کنید:
                            <span class="text-danger">*</span>
                        </label>
                        <textarea type="text" class="form-control" placeholder="متن پیام:" name="description" v-model="form.description"></textarea>
                        <span class="help text-danger" v-if="form.errors.has('description')" v-text="form.errors.get('description')"></span>
                      </div>
                    </div>
                    <div class="form-row d-flex justify-content-center">
                      <div class="col-md-12 mb-3">
                        <label for="validationCustom01">گیرندگان را انتخاب کنید
                            <span class="text-danger">*</span>
                        </label>
                        <br>
                        <span class="help text-danger" v-if="form.errors.has('users')" v-text="form.errors.get('users')"></span>
                        <v-select multiple v-model="form.users" :options="options" label="name" name="users" :select-on-key-codes="form.errors.clear('users')"></v-select>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">بستن</button>
                    <button type="submit" class="btn btn-primary">ایجاد</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center height" v-if="data==null" >
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">در حال بارگذاری ...</span>
          </div>
        </div>
        <div class="table-responsive" v-else>
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>ردیف</th>
                <th>عنوان</th>
                <th v-if="!project_id">پروژه</th>
                <th>ایجاد کننده</th>
                <th>مشاهده</th>
                <th>نام گیرندگان</th>
                <th>وضعیت</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(ticket , index) in data" :key="index" :class="ticket.status === 0 ? '' : 'red'">
                <td>{{index+1}}</td>
                <td v-text="ticket.title"></td>
                <td v-if="!project_id">
                  <div v-if="ticket.project">
                    <router-link class="btn btn-outline-behance"
                      :to="{
                        name:'projects.show',
                        params: { id: ticket.project.id}
                        }">
                      {{ticket.project.name + '-' + ticket.project.code}}
                    </router-link>
                  </div>
                  <div v-else>
                    منتصب به پروژه ای نیست
                  </div>
                </td>
                <td v-text="ticket.user.name"></td>
                <td>
                  <button type="button" class="btn btn-primary m-r-5 mb-2" data-toggle="modal" :data-target="'.showTicketMessages' + ticket.id">نمایش
                  </button>
                  <div :class="'modal fade black showTicketMessages' + ticket.id" tabindex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog modal-lg">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h6 class="modal-title">{{ticket.title}}</h6>
                          <button type="button" class="close" data-dismiss="modal" aria-label="بستن">
                            <i class="ti-close"></i>
                          </button>
                        </div>
                        <div class="modal-body">
                          <div v-for="(message, index) in ticket.ticket_messages" :key="index">
                              <div class="row col-9" v-if="ticket.me===message.user_id">
                              <p>خودم: </p>
                              <p class="text-left">
                                {{message.description}}  ({{message.date}})
                              </p>
                            </div>
                            <div v-else>
                              <div class="row col-9 float-right" dir="ltr">
                                <p>{{message.user.name}}:</p>
                              </div>
                                <div class="row col-9 float-right" dir="ltr">
                                  <p class="text-left">
                                    {{message.description}}  ({{message.date}})
                                  </p>
                                </div>
                            </div>
                          </div>
                          <div class="col-12 float-right" v-if="ticket.status==0">
                            <hr>
                            <label for="">متن پیام را وارد کنید:</label>
                            <textarea type="text" class="form-control" placeholder="متن پیام:" v-model="answer.description"></textarea>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-danger" data-dismiss="modal">بستن</button>
                          <button type="button" class="btn btn-success" @click="submitAnswer(ticket.id)" v-if="ticket.status==0">ارسال پیام</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td >
                  <p v-for="(user, index) in ticket.users" :key="index">
                    {{user.name}}
                  </p>
                </td>
                <td>
                  <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button" class="btn btn-outline-success btn-rounded btn-uppercase" @click="closeTciket(ticket.id)" v-if="ticket.status==0">
                      <i class="ti-key"></i> فعال
                    </button>
                      <button type="button" class="btn btn-outline-danger btn-rounded btn-uppercase" @click="closeTciket(ticket.id)" v-else>
                      <i class="ti-lock"></i> غیرفعال
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th>ردیف</th>
                <th>عنوان</th>
                <th v-if="!project_id">پروژه</th>
                <th>ایجاد کننده</th>
                <th>مشاهده</th>
                <th>نام گیرندگان</th>
                <th>وضعیت</th>
              </tr>
            </tfoot>
          </table>
          <paginations :count="pagination.count" :current="pagination.currentPage" v-on:pages="page"></paginations>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import pagination from '@/mixins/pagination.js'
import paginations from '@/components/partials/paginations.vue'
export default {
  name: 'TicketComponent',
  props: ['url', 'project_id'],
  mixins: [pagination],
  components: {
    paginations
  },
  data () {
    return {
      data: null,
      options: [],
      form: new this.$form({
        title: '',
        users: '',
        description: '',
        project: this.project_id
      }),
      answer: new this.$form({
        description: ''
      })
    }
  },
  beforeCreate () {
    this.$send.submit('get', 'api/ticket/users')
      .then(response => {
        this.options = response
      })
  },
  methods: {
    onSubmit () {
      this.$send.submit('post', 'api/tickets', this.form)
        .then(response => {
          this.form.onSuccess(response)
          window.$('#exampleModalCenter').modal('hide')
          this.start()
        }).catch(error => {
          this.form.onFail(error.errors)
        })
    },
    submitAnswer (id) {
      this.$send.submit('patch', 'api/tickets/' + id, this.answer)
        .then(response => {
          this.answer.onSuccess(response)
          // window.$('.showTicketMessages' + id).modal('hide')
          this.start()
        }).catch(error => {
          this.answer.onFail(error.errors)
        })
    },
    closeTciket (id) {
      this.$send.submit('delete', 'api/tickets/' + id)
        .then(response => {
          this.start()
        })
    }
  }

}

</script>
<style>
.red{
  color:red;
}
.black{
  color:black;
}
</style>
